module.exports = __webpack_public_path__ + "static/img/lgbj.700bf6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/lgbj.png
// module id = IeOF
// module chunks = 1